import React, {useEffect, useState} from "react";
import { useDispatch } from "react-redux";
import { ButtonField } from "@wk/components-react16";
import error403 from "assets/images/403_Image.svg";
import LoadingSpinner from "components/loading/LoadingSpinner";
import { authApi } from "services/auth/authApi";

export const Error403 = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, []);

  const doLogin = async () => {
    const { data, isSuccess } = await dispatch(
      authApi.endpoints.getReloginUrl.initiate({}, { forceRefetch: true })
    );
    if (isSuccess) {
      window.location.href = data.url;
    }
  };

  return (
    <>
    { isLoading ?
      <>
        <LoadingSpinner/>
      </>
      : <>
        <h1>403 - kein Zugriff auf diese Seite</h1>
        <p>Ihr im Moment aktives Benutzerkonto besitzt nicht die erforderliche Berechtigung, um die von Ihnen
          angeforderte Seite "{window.location.pathname}" aufzurufen.</p>
        <br/>
        <div>
          <ButtonField size="large">
            <button className="wk-button wk-button-expanded" onClick={doLogin}>
              Zum Login
            </button>
          </ButtonField>
        </div>
        <div className={"error-image-wrapper"}>
          <img src={error403}/>
        </div>
      </>
    }
    </>
  );
}

export default Error403;
